<template>
  <div style="position: relative;background: black;width: 100vw;height: 100vh;color: white">
    购买JPG宣传页
    <TopShareBar v-if="share"/>
    <div @click="intoOrderPage" class="buy-button">立即订购</div>
  </div>
</template>

<script>
import TopShareBar from "@/components/TopShareBar.vue";

export default {
  name: 'BugJpgLeaflet',
  components: {TopShareBar},
  data() {
    return {
      share: false,
    }
  },
  methods: {
    intoOrderPage() {
      if (this.share) {
        window.location.href = '/OpenApp?infoId=&type=1501'
      } else {
        if (window['flutter_intoJpgOrderPage']) {
          window['flutter_intoJpgOrderPage'].postMessage('')
        }
      }
    },
    addViewCount() {
      this.$http.get('/earthApi/user-picture-shopping-cart/readActivity?activityType=1501').then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          //
        }
      })
    }
  },
  mounted() {
    this.share = this.$route.query.share === '1';
    this.addViewCount()
  }
}
</script>

<style scoped>
.buy-button {
  position: fixed;
  bottom: 50px;
  left: calc(50vw - 105px);
  width: 210px;
  height: 50px;
  border-radius: 13px;
  background: linear-gradient(223.26deg, rgba(71, 140, 255, 1) 0%, rgba(75, 191, 254, 1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
}
</style>